module.exports = __webpack_public_path__ + "img/logo.f1ff00bf.png";